// extracted by mini-css-extract-plugin
export var imgs = "style-module--imgs--c73a2";
export var info = "style-module--info--29a9e";
export var inner = "style-module--inner--0fc13";
export var recs = "style-module--recs--88a73";
export var screen1 = "style-module--screen1--c4585";
export var sub = "style-module--sub--42dbd";
export var sup = "style-module--sup--b28fd";